import request from "@/CommonDP/utils/request";
export default {
  // 默认模块权限
  queryPermissionTreeForCheck(params) {
    return request
      .get("/admin/rolePermission/queryPermissionTreeForCheck", {
        params
      })
      .then((res) => res);
  },
  getSysRoleUserList(params) {
    return request
      .get("/admin/rolePermission/querySysRoleUserList", { params })
      .then((res) => res);
  },
  // 系统角色
  querySysRoleList(enterpriseId) {
    return request
      .get(
        `/admin/rolePermission/querySysRoleList?enterpriseId=${enterpriseId}`
      )
      .then((res) => res);
  },
  // 项目角色
  getPrjRoleTree(enterpriseId, folderArea) {
    return request
      .get(
        `/admin/rolePermission/queryPrjRoleList?enterpriseId=${enterpriseId}&folderArea=${folderArea}`
      )
      .then((res) => res);
  },
  // 默认权限角色
  querySysRoleDefaultList(type) {
    return request
      .get(`/admin/rolePermission/querySysRoleDefaultList?type=${type}`)
      .then((res) => res);
  },
  addRolePermission(params) {
    return request
      .post("/admin/rolePermission/addRolePermission", params)
      .then((res) => res);
  },
  // 单个企业权限资源
  queryPermissionTreeForAssign(businessType, enterpriseId) {
    return request
      .get(
        `/admin/permission/queryPermissionTreeForAssign?businessType=${businessType}&enterpriseId=${enterpriseId}`
      )
      .then((res) => res);
  },
  // 分配单个企业资源
  addPermissionEnterprise(params) {
    return request
      .post("/admin/permission/addPermissionEnterprise", params)
      .then((res) => res);
  },
  // 单个企业角色权限模块
  queryPermissionTreeForEnterpriseCheck(params) {
    return request
      .get("/admin/permission/queryPermissionTreeForEnterpriseCheck", {
        params
      })
      .then((res) => res);
  },

  // 设置/权限管理 文档权限 左侧菜单树
  querySysDocPermissionRoleList(enterpriseId, folderArea) {
    return request
      .get(`/admin/rolePermission/querySysDocPermissionRoleList?enterpriseId=${enterpriseId}&folderArea=${folderArea}`)
      .then((res) => res);
  },
  // 同步到其他专业
  syncProfessionPermissionList(params) {
    return request
      .post("/enterpriseFolderPrivi/syncProfessionPermissionList", params)
      .then((res) => res);
  },
  getEnterprisePrjRoleList(enterpriseId) {
    return request
      .get(`/enterpriseFolderPrivi/getEnterprisePrjRoleList?enterpriseId=${enterpriseId}`)
      .then((res) => res);
  },
  // 成品区左侧树
  getProductAreaTreeList(enterpriseId, folderArea) {
    return request
      .get(
        `/admin/rolePermission/getProductAreaTreeList?enterpriseId=${enterpriseId}&folderArea=${folderArea}`
      )
      .then((res) => res);
  },
  // 同步到其他专业(成品区)
  syncProductAreaRolePermission(params) {
    return request
      .post("/enterpriseFolderPrivi/syncProductAreaRolePermission", params)
      .then((res) => res);
  },
  getPrjOutSideRoleList(enterpriseId) {
    return request
      .get(`/enterprise/prj-manager/getPrjOutSideRoleList?enterpriseId=${enterpriseId}`)
      .then((res) => res);
  },
  getProductAreaTreeNodeList(enterpriseId) {
    return request
      .get(`/enterpriseFolderPrivi/getProductAreaTreeNodeList?enterpriseId=${enterpriseId}`)
      .then((res) => res);
  },
  emptyFinishedArea(enterpriseId) {
    return request
      .get(`/enterpriseFolderPrivi/cleanProductAreaChildFolderPermissions?enterpriseId=${enterpriseId}`)
      .then((res) => res);
  }
};
